import { connect } from 'react-redux';
import { closeModal } from 'components/Modal';
import { createClass } from '../ClasstivityScheduler.saga';
import AddClasstivityClassModal from './AddClasstivityClassModal';

const mapDispatchToProps = dispatch => ({
  handleOnSubmit: (formValues, formAsyncFns) => {
    dispatch(createClass(formValues, formAsyncFns));
  },
  handleOnCancel: () => dispatch(closeModal()),
});

export default connect(null, mapDispatchToProps)(AddClasstivityClassModal);
